/**
 * Utilidades para leer las subcompetencias dinámicas (C1..C7) que trae el
 * backend de alertas genéricas.
 *
 * El número de subcompetencias varía por competencia (RC/LC: 3, CC: 7, CE: 0)
 * y por eso nunca vienen en columnas fijas: hay que descubrir cuáles existen
 * leyendo la llave `C{n}_nombre` de cada fila (espejo de la nota en
 * `resumen_pruebas.py` / `serializers.py` del backend).
 */

const CODIGO_NOMBRE_REGEX = /^(C\d+)_nombre$/;
const NUMERO_CODIGO_REGEX = /^C(\d+)$/;

const numeroDeCodigo = (codigo) => {
  const m = NUMERO_CODIGO_REGEX.exec(String(codigo || ""));
  return m ? Number(m[1]) : 0;
};

/**
 * Códigos de subcompetencia presentes en una fila o lista de filas (RC/LC: C1-C3,
 * CC: C1-C7, CE: ninguno), ordenados C1..C7.
 */
export const codigosSubcompetencia = (filaOFilas) => {
  const filas = Array.isArray(filaOFilas) ? filaOFilas : [filaOFilas];
  const set = new Set();
  filas.forEach((fila) => {
    if (!fila || typeof fila !== "object") return;
    Object.keys(fila).forEach((key) => {
      const m = CODIGO_NOMBRE_REGEX.exec(key);
      if (m) set.add(m[1]);
    });
  });
  return [...set].sort((a, b) => numeroDeCodigo(a) - numeroDeCodigo(b));
};

/** Etiqueta legible de una subcompetencia (cae al código si el backend no la rotuló). */
export const etiquetaSubcompetencia = (fila, codigo) => {
  const nombre = fila && fila[`${codigo}_nombre`];
  return nombre ? String(nombre) : codigo;
};

/**
 * Valor 0–5 de una subcompetencia en una fila de intento (`ResultadoPruebas`).
 * Las subcompetencias no comparten escala entre sí (CC agrupa 2-3 preguntas por
 * código con distinto máximo), así que se usa `C{n}_norm` cuando está disponible.
 */
export const valorNormalizado = (fila, codigo) => {
  if (!fila) return 0;
  const norm = fila[`${codigo}_norm`];
  if (norm !== null && norm !== undefined && Number.isFinite(Number(norm))) {
    return Number(norm);
  }
  return Number(fila[codigo]) || 0;
};

/** Promedio de una subcompetencia en los agregados por programa (`MoodleDataPrograma`). */
export const promedioSubcompetencia = (fila, codigo) => Number(fila?.[`${codigo}_prom`]) || 0;
